<template>
  <div class="offers-header">
    <collapse-panel v-model:is-open="isOpen">
      <template #header>
        <div class="offers-header__header">
          <div class="offers-header__header__address__wrapper">
            <div class="offers-header__header__address">
              <font-awesome-icon
                :icon="['fal', 'truck-moving']"
                class="offers-header__header__icon" />
              <address-header
                :city="demand.from_address.city"
                :date-from="demand.dep_date1"
                :date-to="demand.dep_date2" />
            </div>
            <div class="offers-header__header__address">
              <font-awesome-icon
                :icon="['fal', 'arrow-right']"
                class="offers-header__header__icon" />
              <address-header
                :city="demand.to_address.city"
                :date-from="demand.arr_date1"
                :date-to="demand.arr_date2" />
            </div>
          </div>
          <div class="offers-header__header__formule">
            {{ formule }}
          </div>
        </div>
      </template>
      <template #body>
        <div class="offers-header__body">
          <formule-details />
        </div>
      </template>
    </collapse-panel>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useDemandStore } from '@/stores';
import CollapsePanel from '@/utils/components/CollapsePanel.vue';
import AddressHeader from '@/components/comparator/offers/offersHeader/AddressHeader.vue';
import FormuleDetails from '@/components/comparator/offers/offersHeader/FormuleDetails.vue';

export default {
  name: 'Offer',
  components: {
    CollapsePanel,
    AddressHeader,
    FormuleDetails,
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    ...mapState(useDemandStore, ['demand']),
    formule() {
      return this.demand.formule.title;
    },
  },
};
</script>

<style scoped lang="scss">
.offers-header {
  &__header {
    display: flex;
    flex-wrap: wrap;
    color: var(--nxt-color-font);

    @include breakpoint(mobile) {
      flex-wrap: nowrap;
      justify-content: flex-start;
    }
    &__address__wrapper {
      display: flex;
      flex-wrap: wrap;
      @include breakpoint(mobile) {
        flex-wrap: nowrap;
      }
    }
    &__address {
      display: flex;
      align-items: center;
    }
    &__formule {
      flex-grow: 1;
      text-align: center;
      text-transform: uppercase;
      padding: 5px 10px;
      border-radius: 4px;
      font-weight: 600;
      font-size: 12px;
      margin: 10px 0;
      border: solid 1px var(--nxt-color-primary);
      @include breakpoint(mobile) {
        font-size: 15px;
        margin: 0 auto;
        align-self: center;
      }
    }
    &__icon {
      margin: auto 0;
      width: 20px;
    }
  }
}
</style>
